module.exports = __webpack_public_path__ + "media/img/frontend_application/content_production/service_img-657a76cb6d87f1324f0f9dffab02f878.png";